import { createFileRoute } from '@tanstack/react-router'
import { RouteComponent as InviteUserRouteComponent } from '../(partner)/_partner.invite-user'

export const Route = createFileRoute('/(admin)/_admin/invite')({
  component: InviteUserRouteComponent,
})
